module.exports = __webpack_public_path__ + "img/Suabu Family.e156a22e.svg";